import { getConfig } from './config'

/**
 * @description End point for Quiz
 */
export const QUIZ_ENDPOINT = '/quiz'
/**
 * @description End point for Login
 */
export const LOGIN_ENDPOINT = '/login'
export const LOGOUT_ENDPOINT = '/logout'
export const RESULT_ENDPOINT = '/response'
/**
 * @description end point for admin
 */
export const ADMIN_ENDPOINT = '/admin'

/**
 * @description End point for Compile
 */
export const COMPILE_ENDPOINT = '/compile'
/**
 * @description End point for Live Candidate
 */
export const LIVE_CANDIDATES_ENDPOINT = '/candidates'

/**
 * @description End point for post admin credentials
 */
export const STREAM_CREDENTIALS_ENDPOINT = '/stream-credentials'
/**
 * @description End point for invitees
 */
export const INVITEES_END_POINT = '/invitees'
/**
 * @description End point for billing config
 */
export const BILLING_CONFIG_ENDPOINT = '/billing-config'
/**
 * @description End point for payment
 */
export const PAYMENT_ENDPOINT = '/payment'
export const BILLING_ENDPOINT = '/billing-log'

/**
 * @description Client ID for GAuth
 */

export const getGoogleClientID = () => getConfig().googleClientId

/**
 * @description Client ID for MAuth
 */
export const getAzureClientID = () => getConfig().azureClientId
export const getAzureTenantID = () => getConfig().azureTenantId

/**
 * @description base URL for mock server
 */
export const getBaseUrl = () => getConfig().baseUrl

export const getQuizUrl = () => getConfig().quizUrl

export const getBugsnagKey = () => getConfig().bugsnagKey || ''

export const getFaroAppName = () => getConfig().faroAppName || ''

export const getFaroAppURL = () => getConfig().faroUrl || ''

export const getFaroAPIKey = () => getConfig().faroApiKey || ''

export const BALANCE_ENDPOINT = '/balance'

export const MOBILE_VIEW_WIDTH = 960

export const REFRESH_ENDPOINT = '/refresh'
